/* eslint-disable react/no-array-index-key */
import React, { Component } from "react";
import { Collapse } from "reactstrap";
import Badge from "@material-ui/core/Badge";
import BellIcon from "mdi-react/BellIcon";
import "./Notification.styles.scss";
import { connect } from "react-redux";
import NotificationMiddleware from "../../store/middleware/notificationMiddleware";
import throttle from "lodash.throttle";
import CustomToast from '../../util-functions/customToast.jsx'


class TopbarNotification extends Component {
  state = {
    collapse: false,
    showNotificationDot: false,
    notifications: [],
    allNotifictaion: [],
    noNotification: false,
    myNotifications: [],
    viewed: false,
    page: 1,
    sync: false,
    count: 0,
  };

  socket = null;

  componentDidUpdate() {
    this.recreateSocketConnection();
  }

  load_Notifications() {
    // alert("HELLo")
    if (this.props.isNotificationLoading || this.props.notificationHasError)
      return;
    this.setState(
      {
        page: this.state.page + 1,
      },
      () => {
        this.props.getNotifications(this.state.page, this.state.viewed);
      }
    );
  }

  load_more_notifications = throttle(this.load_Notifications, 800, {
    trailing: false,
  });
  propsReceived = (value) => {
    value.forEach((item) => this.state.allNotifictaion.push(item));
  };
  UNSAFE_componentWillReceiveProps(nextProps) {
    if (
      nextProps.notifications &&
      !nextProps.notificationHasError &&
      !nextProps.isNotificationLoading
    ) {
      this.propsReceived(nextProps.notifications.results);
      let newCount = 0;
      nextProps.notifications.results.forEach((item) => {
        if (item.Viewed === false) {
          newCount = newCount + 1;
        }
      });
      if (newCount > 1) {
        this.setState({
          count: newCount,
          showNotificationDot: true,
        });
      }
    }
  }

  componentDidMount() {
    if (!navigator.onLine) {
      // ToastsStore.error("You are Offline");
      CustomToast('error', 'You are Offline')
      return;
    }
    setTimeout(() => {
    this.props.getNotifications(this.state.page, this.state.viewed);      // Fetch notification from database

    this.createSocketConnection();
    window.addEventListener("online", () => this.recreateSocketConnection());
}, 1000);
    this.page_wrapper.onscroll = (e) => {
      if (this.props.isNotificationLoading) return;
      const obj = e.target;
      const height = obj.scrollHeight - obj.offsetHeight;
      const scrollPos = obj.scrollTop;
      const factor = 0.9;
      if (scrollPos >= factor * height) {
        this.load_more_notifications();
      }
    };
  }

  fetchNotifications = () => {
    setTimeout(() => {

      if (this.props.notifications.results.length >= 1) {
        this.props.notifications.results.forEach((item) => {
          this.state.allNotifictaion.push(item);
        });
        let newCount = 0;
        this.props.notifications.results.forEach((item) => {
          if (item.Viewed === false) {
            newCount = newCount + 1;
          }
        });
        if (newCount > 1) {
          this.setState({
            count: newCount,
            showNotificationDot: true,
          });
        }
      }
      if (this.props.notifications.results === undefined) {
        return;
      }
    }, 2000);
  };

  recreateSocketConnection = () => {
    if (
      !(
        this.socket &&
        (this.socket.readyState == 1 || this.socket.readyState == 0)       // eslint-disable-line
      )
    ) {
      this.createSocketConnection();
    }
  };

  createSocketConnection = () => {
    let user = JSON.parse(localStorage.getItem("myData"));
    this.socket = new WebSocket(
      `wss://staging-unilever.nexdegree.com/b/user/${user.user.guid}`
    );

    this.socket.onopen = () => {
    };

    this.socket.onerror = (e) => {
      this.recreateSocketConnection();
    };

    this.socket.onmessage = (e) => {
      try {
        let notificationContent = JSON.parse(e.data);
        switch (e.type) {
          case "message":
            this.onNewNotificationReceived(notificationContent);
            break;
          default:
            this.onNewNotificationReceived(notificationContent); 
        }
      } catch (e) {
        return false;
      }
    };
  };

  playNotioficationSound() {
    var audio = new Audio(require("../../assets/sounds/notification.mp3"));
    audio.play();
  }

  sendPongToServer = () => {
    this.socket.send(JSON.stringify({ action: "PONG" }));
  };

  startSocketHeartbeat = () => {
    setInterval(() => {
      this.socket.send(JSON.stringify({ action: "PING" }));
    }, 60000);
  };

  timeNow = (value) => {
    var d = new Date(value);
    var hours = d.getHours();
    var minutes = d.getMinutes();
    var ampm = hours >= 12 ? "pm" : "am";
    hours = hours % 12;
    hours = hours ? hours : 12; // the hour '0' should be '12'
    minutes = minutes < 10 ? "0" + minutes : minutes;
    var strTime = hours + ":" + minutes + " " + ampm;
    return strTime;
  };
  currentTime = () => {
    var d = new Date();
    var hours = d.getHours();
    var minutes = d.getMinutes();
    var ampm = hours >= 12 ? "pm" : "am";
    hours = hours % 12;
    hours = hours ? hours : 12; // the hour '0' should be '12'
    minutes = minutes < 10 ? "0" + minutes : minutes;
    var strTime = hours + ":" + minutes + " " + ampm;
    return strTime;
  };
  getDateForNotifications = (value) => {
    var d = new Date(value);
    let date_ = d.toDateString().split(" ");
    return (
      date_[2] +
      `${
        date_[2] == 1       // eslint-disable-line
          ? "st"
          : date_[2] == 2       // eslint-disable-line
          ? "nd"
          : date_[2] == 3       // eslint-disable-line
          ? "rd"
          : "th"
      }` +
      ` ` +
      date_[1] +
      ` ` +
      date_[3]
    );
  };

  currentDate = () => {
    var d = new Date();
    var day = d.getDate();
    var month = d.getMonth() + 1;
    var year = d.getFullYear();
    return day + "/" + month + "/" + year;
  };

  onNewNotificationReceived = (notification) => {
    this.playNotioficationSound();
    notification.date = this.timeNow();
    this.state.myNotifications.unshift(notification);
    this.setState({
      notifications: this.state.myNotifications,
      showNotificationDot: true,
    });
  };

  myAllNotifications = () => (
    <div
      id="scrollbar"
      style={{ overflowY: "auto", height: "300px" }}
      ref={(c) => (this.page_wrapper = c)}
    >
      {!this.state.notifications.length
        ? null
        : this.state.notifications.map((notification, index) => (
            <div key={index}>
              {notification.content !== "" ? (
                <div
                  className={`topbar__collapse-item ${
                    notification.location ? "link" : ""
                  }`}
                  key={index}
                  onClick={(e) => {
                    this.redirectToURL(notification.location,notification.location_name.slice(10,));
                    this.handleViewedNotification(notification.guid);
                  }}
                  style={{ backgroundColor: "#f5f6fa" }}
                >
                  <p className="topbar__collapse-message">
                    {notification.content
                      ? notification.content.length > 100
                        ? notification.content.slice(0, 97) + "..."
                        : notification.content
                      : null}
                    <br />
                    <span style={{ fontSize: "10px", color: "blue" }}>
                      {notification.location_name}
                    </span>
                  </p>
                </div>
              ) : null}
            </div>
          ))}
      {!this.state.allNotifictaion
        ? () => {
            this.setState({ noNotification: true });
          }
        : this.state.allNotifictaion.map((notification, index) => (
            <div key={index}>
              <div
                className={`topbar__collapse-item ${
                  notification.Location ? "link" : ""
                }`}
                key={index}
                onClick={(e) => {
                  this.redirectToURL(notification.Location,notification.LocationName.slice(10,));
                  if (!notification.Viewed) {
                    this.handleViewedNotification(notification.guid);
                  }
                }}
                style={
                  !notification.Viewed ? { backgroundColor: "#EBF2FA " } : null
                }
              >
                <span className="topbar__collapse-message">
                  {notification.Content.length > 100
                    ? notification.Content.slice(0, 97) + "..."
                    : notification.Content}
                  <br />
                  <p style={{ fontSize: "16px", color: "#3f7fc9",margin: '7px 0px 5px 0px' }}>
                    {notification.LocationName}
                  </p>
                  <span className="date_formate">
                    {this.getDateForNotifications(notification.DateCreated)}
                  </span>
                </span>
                </div>
            </div>
          ))}
      {this.state.allNotifictaion.length > 0 ||
      this.state.notifications.length > 1 ? null : (
        <div className="topbar__collapse-no-item">
          <span>Loading.....</span>
        </div>
      )}
    </div>
  );

  componentWillUnmount = () => {
    if (this.socket && this.socket.readyState == 1) {       // eslint-disable-line
      this.socket.close();
    }
  };

  redirectToURL = (urll,activity_code) => {
    if (urll) window.open(urll);
    // window.open(`/${urll}?activity_status=Submitted By Acom&${activity_code}`, '_blank');
  };

  toggle = () => {
    this.setState((prevState) => ({
      collapse: !prevState.collapse,
      showNotificationDot: false,
    }));
  };

  handleViewedNotification = (id) => {
    let notificationIDs = [];
    notificationIDs.push(id);
    this.props.postViewedNotification(notificationIDs);
  };

  render() {
    const { collapse } = this.state;
    return (
      <div className="topbar__collapse">
        <button className="topbar__btn" type="button" onClick={this.toggle}>
          <Badge
            overlap="circle"
            color="default"
            invisible={!this.state.showNotificationDot}
            badgeContent={this.state.notifications.length + this.state.count}
          >
            <BellIcon className="right-btn" />
          </Badge>
        </button>
        {collapse && (
          <button
            className="topbar__back"
            type="button"
            onClick={this.toggle}
          />
        )}
        <Collapse
          isOpen={this.state.collapse}
          className="topbar__collapse-content"
        >
          <div>
            <div className="topbar__collapse-title-wrap">
              <p className="topbar__collapse-title">Notifications</p>
            </div>

            {this.myAllNotifications()}
          </div>
        </Collapse>
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    isNotificationLoading: state.NotificationReducer.isNotificationLoading,
    notifications: state.NotificationReducer.notifications,
    notificationHasError: state.NotificationReducer.notificationHasError,
  };
};

const mapDispatchToprops = (dispatch) => {
  return {
    getNotifications: (page, viewed) => {
      return dispatch(NotificationMiddleware.getNotifications(page, viewed));
    },
    postViewedNotification: (viewedNotifications) => {
      return dispatch(
        NotificationMiddleware.postViewedNotification(viewedNotifications)
      );
    },
  };
};
export default connect(mapStateToProps, mapDispatchToprops)(TopbarNotification);
